import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { CHECK_STATUS } from 'api/checkresponse'
import { useAppSelector } from 'store/hooks'
import { selectCheckresponse } from 'slices/checkresponseSlice'
import { selectFinishdelivery } from 'slices/finishdeliverySlice'
import { CustomerResponse } from 'components/CustomerResponse/CustomerResponse'

export const Next = () => {
  const { response } = useAppSelector(selectCheckresponse)
  const { status } = useAppSelector(selectFinishdelivery)

  const showCustomerResponse = useMemo(() => response?.status === CHECK_STATUS.RESPONDED, [response?.status])
  const error = useMemo(() => status === 'failed', [status])

  const navigate = useNavigate()
  useEffect(() => {
    if (status === 'success') {
      navigate('/finish', { replace: true })
    }
  })

  return (
    <>
      {showCustomerResponse ? (
        <CustomerResponse />
      ) : error ? (
        <Box p={3}>連絡に失敗しました。</Box>
      ) : (
        <Box p={3}>遷移不正です</Box>
      )}
    </>
  )
}
